export default "__VITE_ASSET__cc209536__"